const { addDays } = require('date-fns');

const retentionDays = 60;
// NOTE: クライアントが既存写真の保護を終えるまで自動削除のリリースを遅らせる
const isAutoDeletionEnabled = false;

const fields = () => {
  return {
    expiresOn: {
      type: 'date',
      label: '自動削除日',
      hint: `未設定の場合はレクチャー日の${retentionDays}日後に自動削除されます（保護した画像は削除されません）`,
    },
  };
};

const expiresOnOf = (lectureFrameImages, lecture) => lectureFrameImages?.expiresOn?.toDate() || (lecture?.date && addDays(lecture.date.toDate(), retentionDays));

module.exports = {
  retentionDays,
  isAutoDeletionEnabled,
  fields,
  expiresOnOf,
};
